
import { Directive, Inject, Input, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Directive({
	selector: '[tooltip]',
	host: {
		'(mouseover)': 'onMouseHover($event)',
		'(mouseleave)': 'hideTooltip()',
	}
})

export class TooltipDirective implements OnDestroy {

	private _content: string;

	private tooltipMouseMoveListener = this._onMouseMove.bind(this);

	private tooltipDisplayOffset = 15;
	private tooltipDimensions: { width: number, height: number };
	private windowDimensions: { width: number, height: number };

	@Input() set content(content: string) {
		this._content = content;
	}

	constructor(
		@Inject(DOCUMENT) private _document: any
	) { }

	ngOnDestroy() {
		this.hideTooltip();
	}

	private onMouseHover(event: any) {
		this.tooltipDimensions = null;
		this.windowDimensions = null;

		this.showTooltip(event);
		this._document.addEventListener('mousemove', this.tooltipMouseMoveListener);
	}

	private _onMouseMove(event: any) {
		this.showTooltip(event);
	}

	private showTooltip(event: any) {
		if (this._content) {
			let tooltipDiv = this._document.getElementById('tooltip');
			if (!tooltipDiv) {
				tooltipDiv = this.createToolTipDiv();
			};

			tooltipDiv.innerHTML = this._content;
			tooltipDiv.setAttribute('style',
				'z-index: 100000; padding: 3px 5px; border: 1px solid #DDD; color: #333; background-color: #FFF; position: absolute; font-size: 12px;');
			const position = this.calcPosition(event, tooltipDiv);
			tooltipDiv.style.left = position.x + 'px';
			tooltipDiv.style.top = position.y + 'px';
		}
	}

	private createToolTipDiv() {
		const tooltipDiv = this._document.createElement('div');
		tooltipDiv.setAttribute('id', 'tooltip');
		this._document.querySelector('body').appendChild(tooltipDiv);
		return tooltipDiv;
	}

	private hideTooltip() {
		const tooltipDiv = this._document.getElementById('tooltip');
		if (tooltipDiv) {
			tooltipDiv.innerHTML = '';
			tooltipDiv.setAttribute('style',
				'');
			this._document.removeEventListener('mousemove', this.tooltipMouseMoveListener);
		}
	}


	// caching those is needed for performance reasons
	// because the whole layout is recalculated (reflow)
	// when they are read from the DOM-Element.
	// see: https://gist.github.com/paulirish/5d52fb081b3570c81e3a
	private getTooltipDimensions(tooltipDiv: any) {
		if (!this.tooltipDimensions) {
			this.tooltipDimensions = {
				width: tooltipDiv.offsetWidth,
				height: tooltipDiv.offsetHeight
			};
		}
		return this.tooltipDimensions;
	}

	// see above
	private getWindowDimensions() {
		if (!this.windowDimensions) {
			this.windowDimensions = {
				width: window.innerWidth + window.pageXOffset,
				height: window.innerHeight + window.pageYOffset,
			};
		}
		return this.windowDimensions;
	}

	private calcX(x: number, tooltipWidth: number, windowWidth) {
		const totalOffsetX = this.tooltipDisplayOffset + tooltipWidth;
		if (windowWidth < (x + totalOffsetX)) {
			return (x - totalOffsetX);
		}
		return (x + this.tooltipDisplayOffset);
	}

	private calcY(y: number, tooltipHeight: number, windowHeight: number) {
		const totalOffsetY = this.tooltipDisplayOffset + tooltipHeight;
		if (windowHeight < (y + totalOffsetY)) {
			return (y - totalOffsetY);
		}
		return (y + this.tooltipDisplayOffset);
	}

	private calcPosition(event, tooltipDiv) {
		const tooltipDimensions = this.getTooltipDimensions(tooltipDiv);
		const windowDimensions = this.getWindowDimensions();

		const position = {
			x: this.calcX(event.pageX, tooltipDimensions.width, windowDimensions.width),
			y: this.calcY(event.pageY, tooltipDimensions.height, windowDimensions.height),
		};

		return position;
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/tooltip/tooltip.directive.ts